<template>
  <!-- D: 서브 전용 상품 컴포넌트 -->
  <div class="product-item-se">
    <div class="product-info-se">
      <div class="product-info-txt product-info-txt-se">
        <div class="badge-product-wrap-se">
          <div v-show="!productBadgeEmptyYn" class="c-product-badge-main">
            <span
              v-show="props.product.setgdYn === 'Y'"
              class="badge type-skyblue"
            >
              SET 제품
            </span>
            <span
              v-if="props.product.zzlqdCls == 'A'"
              class="badge type-purple"
            >
              주제
            </span>
            <span
              v-if="props.product.zzlqdCls == 'B'"
              class="badge type-deepgray"
            >
              경화제
            </span>
            <span v-if="props.product.zzlqdCls == 'C'" class="badge type-blue">
              경화촉진제
            </span>
            <span
              v-if="props.product.zzlqdCls == 'D'"
              class="badge type-violet"
            >
              회석제
            </span>
            <span
              v-if="props.product.zzlqdtyCls == 'A'"
              class="badge type-olive"
            >
              1액형
            </span>
            <span
              v-if="props.product.zzlqdtyCls == 'B'"
              class="badge type-olive"
            >
              2액형
            </span>
            <span
              v-if="props.product.zzlqdtyCls == 'C'"
              class="badge type-olive"
            >
              3액형
            </span>
          </div>
          <div class="c-product-category">
            <span class="path"> {{ props.product.prodh1t }} </span>
            <span class="path"> {{ props.product.prodh2t }} </span>
            <span class="path"> {{ props.product.prodh3t }} </span>
          </div>
        </div>
        <div class="product-details-se">
          <span class="product-code">{{ props.product.matnr }}</span>
          <div
            class="product-title-se"
            @click="() => emits('select', props.product)"
          >
            {{ props.product.zzmaktx }}
          </div>
        </div>
        <!-- <div class="product-price-se">{{ props.product.bomTotalQty }}</div> -->
         <div class="c-counter">
            <button type="button" class="btn-minus" @click="
                () => emits('minus', { product: props.product})
              ">
              <i class="c-icon icon-minus size-xxsmall"></i>
              <span class="sr-only">빼기</span>
            </button>
            <input
              type="number"
              title="수량입력"
              @input="changeQuantity"
              :value=props.product.quantity>
            <button type="button" class="btn-plus" @click="
                () => emits('plus', { product: props.product})
              ">
              <i class="c-icon icon-plus-black size-xxsmall"></i>
              <span class="sr-only">더하기</span>
            </button>
          </div>
      </div>
      <div class="product-main-pr01">
        <div class="action-buttons">
          <div class="c-btn-area-list type-product c-btn-area-list-se  type-inline">
            <div class="stock-block">
              <button
                class="btn-pc-pr btn-outlined"
                @click="() => (data.totalStockListPopEl = true)"
              >
                재고
              </button>
              <div class="stock-lines" aria-label="재고 현황" v-if="data.productStocksFlag" >
                <span class="stock-line" v-for="stock in data.productStocks" :key="stock.werks">
                  <template v-if="stock.matnr == 'qtySum' && (props.product.setgdYn === 'Y' || data.productStocks.length > 5 )">
                    재고수량 : <strong>{{ stock.labst }}</strong>
                  </template>
                  <template v-if="data.productStocks.length <= 5 && props.product.setgdYn !== 'Y'">
                    {{
                      Utils.replace(
                        Utils.codeNm(props.werks, stock.werks),
                        "노루페인트",
                        ""
                      )
                    }}
                    :
                    <strong>{{ Utils.currency(stock.labst) }}</strong>
                  </template>
                </span>
              </div>
            </div>
            <button
              type="button"
              class="c-button type-white type-xsmall type-icon c-button-se"
              data-basket="basket1"
              @click="
                () => emits('cart', { product: props.product, quantity: 1 })
              "
            >
              담기
              <!-- <i class="c-icon icon-basket-product"></i> -->
              <span class="sr-only">장바구니</span>
            </button>
            <button
              type="button"
              class="btn-pc-pr btn-outlined"
              data-basket="quickOrder1"
              @click="
                () => pushMyRoom(props.product.matnr, props.product.mtart)
              "
            >
              마이룸담기
            </button>
            <button
              type="button"
              class="btn-pc-pr btn-primary btn-pc-pr-btn"
              data-basket="quickOrder1"
              @click="() => emits('buy', { ...props.product, quantity: props.product.quantity })"
            >
              바로주문
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="c-toast-black" data-toast="basket1">
    <span class="text">장바구니에 담겼습니다</span>
  </div>
  <div class="c-toast-black is-quick" data-toast="quickOrder1">
    <span class="text">주문서에 담겼습니다주문서에 담겼습니다</span>
  </div>

  <AlertWerks
    :totalStockListPopEl="data.totalStockListPopEl"
    :product="props.product"
    :werks="props.werks"
    @close="() => (data.totalStockListPopEl = false)"
    @checkStock="(productStocks) => checkProdStck(productStocks)"
  >
  </AlertWerks>

  <myRoomGroupSelect
    v-if="data.isShowGroupInfoPop"
    :product="props.product"
    @close="() => (data.isShowGroupInfoPop = false)"
  />
</template>
<script setup>
import { onMounted, defineProps, defineEmits, computed, reactive } from "vue";
import Utils from "@/js/utils";
import AlertWerks from "@/components/paintpro/common/AlertWerks.vue";
import myRoomGroupSelect from "@/components/paintpro/myRoom/myRoomGroupSelect.vue";


//const FILE_CDN_URL = process.env.VUE_APP_FILE_CDN_URL;
/*
  props.product: {
      "matnr": "PUA000001/55K",
      "zzmaktx": "광택스(DX-0055)",
      "mtart": "FERT",
      "zzprdTyp": "A",
      "zzlqdCls": "A",
      "zzlqdtyCls": "A",
      "zzmatnrLqA": "1",
      "zzmatnrLqB": "1",
      "zzmatnrLqC": "1",
      "zzcolorTyp": "흰색 계열",
      "zztotalQty": "18L",
      "matkl": "P0101",
      "wgbez": null,
      "prodh1": "10003",
      "prodh1t": "건축수성",
      "prodh2": "1000300004",
      "prodh2t": "수성내부",
      "prodh3": "100030000400000006",
      "prodh3t": "내츄럴 듀프리코트",
      "zlgcReqno": "1",
      "setgdYn": "N",
      "goodsSn": "55",
      "imgFileSn": null,
      "imgFilePath": null,
      "imgFileNm": null,
      "kbetr": 12070,
      "purchaseCount": 0,
      "regDt": "2024-12-10T15:00:00.000+00:00"
  },
*/


const props = defineProps({
  product: {
    type: Object,
    required: true,
  },
  werks: {
    type: Object,
    required: true,
  },
  index: {
    type: Object,
    required: true,
  }
});

const data = reactive({
  isShowGroupInfoPop: false,
  totalStockListPopEl: false,
  productStocks : [],
  productStocksFlag : false
});

const emits = defineEmits(["buy", "cart", "select", "plus", "minus", "updateQuantity"]);
//const imageErrorYn = ref(false);

const changeQuantity = (event) => {
  emits('updateQuantity', event.target.value);
};

onMounted(() => {});

const productBadgeEmptyYn = computed(() => {
  return (
    props.product.setgdYn !== "Y" &&
    props.product.zzlqdCls !== "A" &&
    props.product.zzlqdCls !== "B" &&
    props.product.zzlqdCls !== "C" &&
    props.product.zzlqdCls !== "D" &&
    props.product.zzlqdtyCls !== "A" &&
    props.product.zzlqdtyCls !== "B" &&
    props.product.zzlqdtyCls !== "C"
  );
});

// 그룹관리
function pushMyRoom() {
  data.isShowGroupInfoPop = true;
}

function checkProdStck(productStocks) {
  if(productStocks.length > 0){
    data.productStocks = productStocks;
    data.productStocksFlag = true;
  }
}


// const isNoPcImage = computed(() => {
//   return (
//     Utils.isBlank(props.product.imgFilePath) ||
//     Utils.isBlank(props.product.imgFileNm) ||
//     imageErrorYn.value
//   );
// });

// const imageFilePath = computed(() => {
//   return (
//     FILE_CDN_URL +
//     "/" +
//     props.product.imgFilePath +
//     "/" +
//     props.product.imgFileNm
//   );
// });
</script>
